import React from 'react'
import PageTitle from '../components/PageTitle'
import GroceryList from '../components/GroceryList'

export default () => (
  <>
    <PageTitle title="Grocery List:" />
    <GroceryList />
  </>
)